import { render } from "./TeamNameTakenDialog.vue?vue&type=template&id=e4a879ba"
import script from "./TeamNameTakenDialog.vue?vue&type=script&lang=js"
export * from "./TeamNameTakenDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__